import * as THREE from 'three';
import EventDispatcher from '../common/EventDispatcher';
import { Global } from '../common/global';

export default class SwipeInput {
  constructor() {
    this.events = EventDispatcher.getObj();
    this.swipeStart = new THREE.Vector2();
    this.swipeTime = 0;
    this.isActive = false;
    this.isFirstSwipe = true;
    this.handleStart = this.handleStart.bind(this);
    this.handleEnd = this.handleEnd.bind(this);

    this.initListeners();
  }

  initListeners() {
    // Pointer/Mouse
    window.addEventListener('mousedown', this.handleStart);
    window.addEventListener('mouseup', this.handleEnd);

    // Touch
    window.addEventListener('touchstart', this.handleStart, { passive: false });
    window.addEventListener('touchend', this.handleEnd, { passive: false });
  }

  /**
   * Helper to extract coordinates from Mouse or Touch events
   */
  getCoords(e) {
    // If it's a touch event, use the first touch (or changedTouch for end event)
    if (e.touches && e.touches.length > 0) {
      return { x: e.touches[0].clientX, y: e.touches[0].clientY };
    } else if (e.changedTouches && e.changedTouches.length > 0) {
      return { x: e.changedTouches[0].clientX, y: e.changedTouches[0].clientY };
    }
    // Fallback for Mouse
    return { x: e.clientX, y: e.clientY };
  }

  setEnabled(bool) {
    this.isActive = bool;
  }

  handleStart(e) {
    if (!this.isActive) return;

    const coords = this.getCoords(e);
    this.swipeStart.set(coords.x, coords.y);
    this.swipeTime = Date.now();
  }

  handleEnd(e) {
    // if (!this.isActive) return;

    const coords = this.getCoords(e);
    const swipeEnd = new THREE.Vector2(coords.x, coords.y);
    const duration = (Date.now() - this.swipeTime) / 1000;

    // Calculate deltas in pixels
    const deltaX = swipeEnd.x - this.swipeStart.x;
    const deltaY = this.swipeStart.y - swipeEnd.y;
    const distance = swipeEnd.distanceTo(this.swipeStart);

    // Ignore tiny taps (Deadzone)
    if (distance < 30 || deltaY <= 0) return;

    const speed = distance / Math.max(0.1, duration);

    // --- CALIBRATION ---
    // Using innerHeight as reference for both axes fixes the Mobile vs Desktop sensitivity.
    const ref = window.innerHeight;

    const velX = (deltaX / ref) * 25;
    const velY = Math.max(6, (deltaY / ref) * 20);

    // speed / ref gives us a "percentage of screen height per second"
    const normalizedSpeed = speed / ref;
    const velZ = -Math.min(30, Math.max(2, normalizedSpeed * 10));

    Global.velocity = new THREE.Vector3(velX, velY, velZ);

    if (Global.canSwipe && Global.isGameActive) {
      this.events.dispatchEvent({
        type: 'PLAYER_EVENTS',
        message: {
          event_type: 'kick_ball',
          data: {
            //   velocity: { x: velX, y: velY, z: velZ },
          },
        },
      });
    }

    // if (Global.canSwipe && this.isFirstSwipe) {
    //   this.isFirstSwipe = false;
    //   this.events.dispatchEvent({
    //     type: 'GAMESCENE_EVENTS',
    //     message: {
    //       event_type: 'hide_home',
    //       data: {
    //         screenKey: 'Home',
    //       },
    //     },
    //   });
    // }

    // this.isActive = false;
  }
}
